import { Link } from 'react-router-dom'
import IncidentFirstSteps from './IncidentFirstSteps'

/**
 * Confirmación de un reporte de incidente: código asignado y, debajo, los
 * primeros pasos que la persona debe seguir mientras el equipo lo revisa.
 *
 * @component
 * @param {Object} props
 * @param {Object} props.incident - Incidente creado (Code).
 * @param {Object} props.firstSteps - Estado de `useIncidentFirstSteps`.
 * @param {() => void} props.onRetry - Reintentar la guía con IA.
 * @param {() => void} props.onReportAnother
 * @returns {JSX.Element}
 */
const IncidentReportSuccess = ({
  incident,
  firstSteps,
  onRetry,
  onReportAnother,
}) => (
  <div className="irs">
    <div className="irs-head">
      <i className="fa-solid fa-circle-check" />
      <div>
        <h5 className="mb-1">Reporte enviado</h5>
        <p className="mb-0">
          Quedó registrado con el código <strong>{incident.Code}</strong>. El
          equipo de seguridad lo revisará y le dará seguimiento.
        </p>
      </div>
    </div>

    <h6 className="irs-title">Qué hacer ahora</h6>
    <IncidentFirstSteps
      guide={firstSteps.guide}
      loading={firstSteps.loading}
      aiError={firstSteps.aiError}
      onRetry={onRetry}
    />

    <div className="irs-actions">
      <button
        type="button"
        className="btn btn-sm btn-light"
        onClick={onReportAnother}
      >
        Reportar otro
      </button>
      <Link to="/" className="btn btn-sm btn-primary">
        Volver al inicio
      </Link>
    </div>

    <style>{`
      .irs { display: flex; flex-direction: column; gap: 14px; }
      .irs-head { display: flex; gap: 14px; align-items: flex-start; padding: 14px 16px; border-radius: 12px; background: rgba(34, 197, 94, 0.08); border: 1px solid rgba(34, 197, 94, 0.25); }
      .irs-head > i { font-size: 1.6rem; color: var(--gm-success); }
      .irs-head h5 { font-weight: 700; color: var(--gm-text); }
      .irs-head p { font-size: 0.86rem; color: var(--gm-text-muted); }
      .irs-title { margin: 4px 0 0; font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--gm-text-muted); }
      .irs-actions { display: flex; justify-content: flex-end; gap: 8px; }
    `}</style>
  </div>
)

export default IncidentReportSuccess
